<div class="vertical-role-container">
  <div class="sm-flex sm-flex-row sm-gap-x-2">
    <label i18n for="industry" class="sm-w-1/3">Industry</label>
    <div class="vertical-selector sm-w-2/3">
      <ng-select
        [items]="verticalOptions"
        bindLabel="name"
        loadingText="Loading..."
        #verticalSelector
        class="dropdown-selector vertical-dropdown"
        appendTo="body"
        [placeholder]="selectPlaceholder"
        [(ngModel)]="selectedVertical"
        [clearable]="false"
        (change)="onSelectionChange(); verticalSelector.blur()"
      >
      </ng-select>
    </div>
  </div>
  <div class="sm-flex sm-flex-row sm-gap-x-2">
    <label i18n for="role" class="sm-w-1/3">Role</label>
    <div class="role-selector sm-w-2/3">
      <ng-select
        #roleSelector
        class="dropdown-selector role-dropdown"
        appendTo="body"
        [items]="roleOptions"
        bindLabel="name"
        loadingText="Loading..."
        [placeholder]="selectPlaceholder"
        [(ngModel)]="selectedRole"
        [clearable]="false"
        (change)="onSelectionChange(); roleSelector.blur()"
      >
      </ng-select>
    </div>
  </div>
</div>
